import React, { useState } from 'react';
import RefreshIcon from "@mui/icons-material/Refresh";
import { Paper, Button, Box, Typography, TextField, Alert } from '@mui/material';
import SearchIcon from "@mui/icons-material/Search";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Navbar from '../navbar';

const ViewallAppointments = () => {
  const navigate = useNavigate();
  const [validationError, setValidationError] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const handleSearch = () => {
    if (!startDate || !endDate) { setValidationError('Both dates must be selected'); return; }
    if (startDate > endDate) { setValidationError('Start date must not be greater than end date'); return; }
    navigate("/appointments-results", { state: { startDate, endDate } });
  };

  const handleClearFilters = () => { setStartDate(''); setEndDate(''); setValidationError(''); };

  return (
    <>
      <Navbar />
      <Box sx={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)', px: { xs: 2, sm: 4 }, pb: 5, pt: 3 }}>

        <Box sx={{ mb: 4 }}>
          <Typography sx={{ fontWeight: 700, fontSize: '1.15rem', color: '#111827' }}>
            View All Appointments
          </Typography>
          <Typography sx={{ fontSize: '0.82rem', color: '#6b7280', mt: 0.3 }}>
            Select a date range to review and track appointments
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <Paper elevation={0} sx={{
            border: '1px solid #e2e8f0', borderRadius: 3, bgcolor: '#fff',
            p: { xs: 3, sm: 4 }, width: '100%', maxWidth: 540,
          }}>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
              <Box sx={{ bgcolor: '#eff6ff', borderRadius: 2, p: 1, display: 'flex' }}>
                <DateRangeOutlinedIcon sx={{ color: '#3b82f6', fontSize: '1.2rem' }} />
              </Box>
              <Box>
                <Typography sx={{ fontWeight: 700, fontSize: '0.95rem', color: '#111827' }}>Date Range</Typography>
                <Typography sx={{ fontSize: '0.78rem', color: '#6b7280' }}>Both fields are required</Typography>
              </Box>
            </Box>

            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2.5 }}>
              <TextField
                label="Start Date" type="date" value={startDate}
                onChange={(e) => { setStartDate(e.target.value); setValidationError(''); }}
                size="small" InputLabelProps={{ shrink: true }}
                sx={{ flex: 1, minWidth: 160, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
              />
              <TextField
                label="End Date" type="date" value={endDate}
                onChange={(e) => { setEndDate(e.target.value); setValidationError(''); }}
                size="small" InputLabelProps={{ shrink: true }}
                sx={{ flex: 1, minWidth: 160, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
              />
            </Box>

            {validationError && (
              <Alert severity="error" sx={{ mb: 2, borderRadius: 2, fontSize: '0.82rem' }}>{validationError}</Alert>
            )}

            <Box sx={{ display: 'flex', gap: 1.5 }}>
              <Button
                variant="contained" onClick={handleSearch} fullWidth
                disabled={!startDate || !endDate} startIcon={<SearchIcon />}
                sx={{
                  textTransform: 'none', fontWeight: 600, borderRadius: 2, py: 1.1,
                  bgcolor: '#3b82f6', boxShadow: 'none',
                  '&:hover': { bgcolor: '#2563eb', boxShadow: 'none' },
                  '&.Mui-disabled': { bgcolor: '#3b82f6', color: '#fff', opacity: 0.5 },
                }}
              >
                Search Appointments
              </Button>
              <Button
                variant="outlined" onClick={handleClearFilters}
                sx={{
                  borderRadius: 2, minWidth: 44, width: 44, p: 0,
                  borderColor: '#e2e8f0', color: '#6b7280',
                  '&:hover': { borderColor: '#3b82f6', color: '#3b82f6', bgcolor: '#eff6ff' },
                }}
              >
                <RefreshIcon sx={{ fontSize: '1.1rem' }} />
              </Button>
            </Box>
          </Paper>
        </Box>
      </Box>
    </>
  );
};

export default ViewallAppointments;
